// SEO utility functions for dynamic meta tags

const SITE_URL = 'https://leasertech.com';

export const TARGET_KEYWORDS = [
  'bluetooth kulaklık',
  'kablosuz kulaklık',
  'kablolu kulaklık',
  'kulaklık',
  'powerbank',
  'ses bombası',
  'bluetooth hoparlör',
  'bt hoparlör',
  'projeksiyon cihazı',
  'oyun projeksiyonu',
  'game projeksiyon',
  'taşınabilir projeksiyon',
  'elektronik aksesuar'
];

const CATEGORY_SEO = {
  'Kulaklık': {
    title: 'Kulaklık Modelleri | Bluetooth, Kablosuz & Kablolu Kulaklık - LeaserTech',
    description: 'Bluetooth kulaklık, kablosuz kulaklık ve kablolu kulaklık modelleri LeaserTech\'te. Uygun fiyat, hızlı kargo ve güvenli ödeme ile hemen sipariş verin.',
    keywords: 'kulaklık, bluetooth kulaklık, kablosuz kulaklık, kablolu kulaklık, wireless kulaklık, kulaklık fiyatları, kulaklık modelleri, LeaserTech',
    intro: 'Bluetooth kulaklık, kablosuz kulaklık ve kablolu kulaklık modellerini uygun fiyatlarla keşfedin. Günlük kullanım, spor ve oyun için geniş kulaklık seçenekleri LeaserTech\'te.'
  },
  'Hoparlör': {
    title: 'Bluetooth Hoparlör & Ses Bombası | BT Hoparlör - LeaserTech',
    description: 'Bluetooth hoparlör, ses bombası ve taşınabilir BT hoparlör modelleri. Yüksek ses kalitesi, uygun fiyat ve hızlı teslimat LeaserTech\'te.',
    keywords: 'bluetooth hoparlör, bt hoparlör, ses bombası, kablosuz hoparlör, taşınabilir hoparlör, hoparlör fiyatları, ses bombası fiyat, LeaserTech',
    intro: 'Bluetooth hoparlör ve ses bombası modelleri ile müziğinizi her yere taşıyın. Taşınabilir BT hoparlör seçeneklerini LeaserTech güvencesiyle inceleyin.'
  },
  'Powerbank': {
    title: 'Powerbank Modelleri | Taşınabilir Şarj Cihazları - LeaserTech',
    description: 'Yüksek kapasiteli powerbank ve taşınabilir şarj cihazları. Hızlı şarj destekli powerbank modelleri uygun fiyatlarla LeaserTech\'te.',
    keywords: 'powerbank, taşınabilir şarj, power bank, şarj cihazı, hızlı şarj powerbank, powerbank fiyatları, LeaserTech',
    intro: 'Powerbank ve taşınabilir şarj cihazları ile cihazlarınızı her an şarj edin. Farklı kapasite ve hızlı şarj destekli powerbank modelleri burada.'
  },
  'Projeksiyon Cihazları': {
    title: 'Projeksiyon Cihazları | Oyun & Taşınabilir Projeksiyon - LeaserTech',
    description: 'Projeksiyon cihazı, oyun projeksiyonu, game projeksiyon ve taşınabilir projeksiyon modelleri. Ev sineması ve gaming için ideal çözümler LeaserTech\'te.',
    keywords: 'projeksiyon cihazı, projeksiyon cihazları, oyun projeksiyonu, game projeksiyon, taşınabilir projeksiyon, gaming projektör, projeksiyon makinesi, LeaserTech',
    intro: 'Oyun projeksiyonu, taşınabilir projeksiyon ve game projeksiyon modelleri ile ev sineması ve gaming deneyiminizi zenginleştirin.'
  },
  'Telefon Aksesuarları': {
    title: 'Telefon Aksesuarları | Kılıf, Kablo ve Daha Fazlası - LeaserTech',
    description: 'Telefon aksesuarları, kılıf, kablo ve mobil aksesuar modelleri. Uygun fiyat, hızlı kargo LeaserTech\'te.',
    keywords: 'telefon aksesuarları, mobil aksesuar, telefon kılıfı, telefon kablosu, LeaserTech',
    intro: 'Telefon aksesuarları kategorisinde ihtiyacınız olan tüm ürünleri uygun fiyatlarla bulun.'
  },
  'Telefon Tutacakları': {
    title: 'Telefon Tutacakları | Araç ve Masaüstü Tutucular - LeaserTech',
    description: 'Telefon tutacağı, araç telefon tutacağı ve masaüstü tutucu modelleri. Pratik kullanım, uygun fiyat LeaserTech\'te.',
    keywords: 'telefon tutacağı, araç telefon tutacağı, telefon standı, telefon tutacakları, LeaserTech',
    intro: 'Araç ve masaüstü kullanım için telefon tutacağı modellerini keşfedin.'
  },
  'Şarj Aleti': {
    title: 'Şarj Aleti Modelleri | Hızlı Şarj Adaptörleri - LeaserTech',
    description: 'Şarj aleti ve hızlı şarj adaptörü modelleri. Güvenli, uyumlu ve uygun fiyatlı şarj çözümleri LeaserTech\'te.',
    keywords: 'şarj aleti, hızlı şarj, şarj adaptörü, type-c şarj, LeaserTech',
    intro: 'Hızlı şarj destekli şarj aleti modelleri ile cihazlarınızı güvenle şarj edin.'
  },
  'Bilgisayar Aksesuarları': {
    title: 'Bilgisayar Aksesuarları | Klavye, Mouse ve Daha Fazlası - LeaserTech',
    description: 'Bilgisayar aksesuarları, klavye, mouse ve çevre birimi modelleri. Uygun fiyat, hızlı teslimat LeaserTech\'te.',
    keywords: 'bilgisayar aksesuarları, klavye, mouse, pc aksesuar, LeaserTech',
    intro: 'Bilgisayar aksesuarları ile çalışma ve oyun deneyiminizi geliştirin.'
  },
  'Otomobil Ürünleri': {
    title: 'Otomobil Ürünleri | Araç Aksesuarları - LeaserTech',
    description: 'Otomobil ürünleri ve araç aksesuarları. Pratik, kaliteli ve uygun fiyatlı çözümler LeaserTech\'te.',
    keywords: 'otomobil ürünleri, araç aksesuarları, araba aksesuar, LeaserTech',
    intro: 'Otomobil ürünleri kategorisinde araç içi konfor ve pratiklik sağlayan aksesuarları keşfedin.'
  }
};

const SEARCH_SEO = {
  'bluetooth kulaklık': {
    title: 'Bluetooth Kulaklık Modelleri ve Fiyatları - LeaserTech',
    description: 'Bluetooth kulaklık modelleri uygun fiyatlarla LeaserTech\'te. Kablosuz kulaklık seçeneklerini hemen inceleyin, hızlı kargo ile sipariş verin.',
    keywords: 'bluetooth kulaklık, kablosuz kulaklık, bluetooth kulaklık fiyatları, kulaklık modelleri'
  },
  'kablosuz kulaklık': {
    title: 'Kablosuz Kulaklık | Bluetooth Kulaklık - LeaserTech',
    description: 'Kablosuz kulaklık ve bluetooth kulaklık modelleri. Uygun fiyat, hızlı teslimat LeaserTech\'te.',
    keywords: 'kablosuz kulaklık, bluetooth kulaklık, wireless kulaklık, kulaklık'
  },
  'kablolu kulaklık': {
    title: 'Kablolu Kulaklık Modelleri - LeaserTech',
    description: 'Kablolu kulaklık modelleri uygun fiyatlarla. Kaliteli ses deneyimi için LeaserTech\'i ziyaret edin.',
    keywords: 'kablolu kulaklık, kulaklık, kablolu kulaklık fiyatları'
  },
  'kulaklık': {
    title: 'Kulaklık Modelleri | Bluetooth & Kablolu - LeaserTech',
    description: 'Kulaklık, bluetooth kulaklık ve kablolu kulaklık modelleri. Geniş ürün yelpazesi LeaserTech\'te.',
    keywords: 'kulaklık, bluetooth kulaklık, kablosuz kulaklık, kablolu kulaklık'
  },
  'powerbank': {
    title: 'Powerbank Modelleri ve Fiyatları - LeaserTech',
    description: 'Powerbank ve taşınabilir şarj cihazları uygun fiyatlarla. Hızlı kargo LeaserTech\'te.',
    keywords: 'powerbank, power bank, taşınabilir şarj, şarj cihazı'
  },
  'ses bombası': {
    title: 'Ses Bombası Modelleri | Bluetooth Hoparlör - LeaserTech',
    description: 'Ses bombası ve bluetooth hoparlör modelleri. Taşınabilir, güçlü ses LeaserTech\'te.',
    keywords: 'ses bombası, bluetooth hoparlör, bt hoparlör, kablosuz hoparlör'
  },
  'bluetooth hoparlör': {
    title: 'Bluetooth Hoparlör & BT Hoparlör - LeaserTech',
    description: 'Bluetooth hoparlör, ses bombası ve taşınabilir hoparlör modelleri LeaserTech\'te.',
    keywords: 'bluetooth hoparlör, bt hoparlör, ses bombası, kablosuz hoparlör'
  },
  'bt hoparlör': {
    title: 'BT Hoparlör Modelleri | Bluetooth Hoparlör - LeaserTech',
    description: 'BT hoparlör ve bluetooth hoparlör modelleri uygun fiyatlarla LeaserTech\'te.',
    keywords: 'bt hoparlör, bluetooth hoparlör, ses bombası'
  },
  'hoparlör': {
    title: 'Hoparlör Modelleri | Bluetooth & Ses Bombası - LeaserTech',
    description: 'Hoparlör, bluetooth hoparlör ve ses bombası modelleri LeaserTech\'te.',
    keywords: 'hoparlör, bluetooth hoparlör, ses bombası, bt hoparlör'
  },
  'projeksiyon cihazı': {
    title: 'Projeksiyon Cihazı Modelleri - LeaserTech',
    description: 'Projeksiyon cihazı, taşınabilir projeksiyon ve oyun projeksiyonu modelleri LeaserTech\'te.',
    keywords: 'projeksiyon cihazı, projeksiyon cihazları, taşınabilir projeksiyon, oyun projeksiyonu'
  },
  'projeksiyon cihazları': {
    title: 'Projeksiyon Cihazları | Oyun & Taşınabilir - LeaserTech',
    description: 'Projeksiyon cihazları, game projeksiyon ve taşınabilir projeksiyon modelleri LeaserTech\'te.',
    keywords: 'projeksiyon cihazları, projeksiyon cihazı, oyun projeksiyonu, game projeksiyon'
  },
  'oyun projeksiyonu': {
    title: 'Oyun Projeksiyonu | Game Projeksiyon Cihazları - LeaserTech',
    description: 'Oyun projeksiyonu ve game projeksiyon modelleri. Gaming deneyimi için ideal projeksiyon cihazları LeaserTech\'te.',
    keywords: 'oyun projeksiyonu, game projeksiyon, gaming projektör, projeksiyon cihazı'
  },
  'game projeksiyon': {
    title: 'Game Projeksiyon Cihazları | Oyun Projeksiyonu - LeaserTech',
    description: 'Game projeksiyon ve oyun projeksiyonu modelleri. Taşınabilir projeksiyon seçenekleri LeaserTech\'te.',
    keywords: 'game projeksiyon, oyun projeksiyonu, gaming projektör, taşınabilir projeksiyon'
  },
  'taşınabilir projeksiyon': {
    title: 'Taşınabilir Projeksiyon Cihazları - LeaserTech',
    description: 'Taşınabilir projeksiyon, oyun projeksiyonu ve projeksiyon cihazı modelleri LeaserTech\'te.',
    keywords: 'taşınabilir projeksiyon, projeksiyon cihazı, oyun projeksiyonu, mini projeksiyon'
  }
};

const getCategoryKeywords = (categories = []) => {
  const keywords = new Set();

  categories.forEach((category) => {
    if (CATEGORY_SEO[category]?.keywords) {
      CATEGORY_SEO[category].keywords.split(', ').forEach((keyword) => keywords.add(keyword));
    }
  });

  if (categories.includes('Kulaklık')) {
    ['bluetooth kulaklık', 'kablosuz kulaklık', 'kablolu kulaklık'].forEach((k) => keywords.add(k));
  }
  if (categories.includes('Hoparlör')) {
    ['bluetooth hoparlör', 'bt hoparlör', 'ses bombası'].forEach((k) => keywords.add(k));
  }
  if (categories.includes('Projeksiyon Cihazları')) {
    ['oyun projeksiyonu', 'game projeksiyon', 'taşınabilir projeksiyon'].forEach((k) => keywords.add(k));
  }

  return [...keywords];
};

export const updatePageSEO = (title, description, keywords = '', image = '', url = '') => {
  document.title = title;

  const metaDescription = document.querySelector('meta[name="description"]');
  if (metaDescription) {
    metaDescription.setAttribute('content', description);
  }

  const metaKeywords = document.querySelector('meta[name="keywords"]');
  if (metaKeywords) {
    metaKeywords.setAttribute('content', keywords);
  }

  const ogTitle = document.querySelector('meta[property="og:title"]');
  if (ogTitle) {
    ogTitle.setAttribute('content', title);
  }

  const ogDescription = document.querySelector('meta[property="og:description"]');
  if (ogDescription) {
    ogDescription.setAttribute('content', description);
  }

  const ogImage = document.querySelector('meta[property="og:image"]');
  if (ogImage && image) {
    ogImage.setAttribute('content', image);
  }

  const ogUrl = document.querySelector('meta[property="og:url"]');
  if (ogUrl && url) {
    ogUrl.setAttribute('content', url);
  }

  const twitterTitle = document.querySelector('meta[name="twitter:title"]');
  if (twitterTitle) {
    twitterTitle.setAttribute('content', title);
  }

  const twitterDescription = document.querySelector('meta[name="twitter:description"]');
  if (twitterDescription) {
    twitterDescription.setAttribute('content', description);
  }

  const twitterImage = document.querySelector('meta[name="twitter:image"]');
  if (twitterImage && image) {
    twitterImage.setAttribute('content', image);
  }

  const canonical = document.querySelector('link[rel="canonical"]');
  if (canonical && url) {
    canonical.setAttribute('href', url);
  }
};

export const seoTemplates = {
  home: {
    title: 'LeaserTech | Bluetooth Kulaklık, Powerbank, Hoparlör & Projeksiyon Cihazları',
    description: 'LeaserTech\'te bluetooth kulaklık, kablosuz kulaklık, powerbank, ses bombası, bluetooth hoparlör ve taşınabilir projeksiyon cihazları. Uygun fiyat, hızlı kargo, güvenli ödeme.',
    keywords: TARGET_KEYWORDS.join(', ')
  },

  products: {
    title: 'Elektronik Aksesuarlar | Kulaklık, Hoparlör, Powerbank - LeaserTech',
    description: 'Bluetooth kulaklık, kablolu kulaklık, powerbank, ses bombası, bt hoparlör ve projeksiyon cihazları. Tüm elektronik aksesuarlar LeaserTech\'te.',
    keywords: TARGET_KEYWORDS.join(', ')
  },

  productDetail: (product) => {
    const productName = product.name || '';
    const brand = product.brand || '';
    const categories = product.categories || [];
    const description = product.description || '';
    const categoryKeywords = getCategoryKeywords(categories);

    let metaDescription = '';
    if (description.length > 0) {
      metaDescription = description.substring(0, 155);
      if (description.length > 155) {
        const lastSpace = metaDescription.lastIndexOf(' ');
        if (lastSpace > 120) {
          metaDescription = metaDescription.substring(0, lastSpace);
        }
      }
      metaDescription += '... ';
    } else {
      metaDescription = `${productName}${brand ? ` - ${brand}` : ''}. `;
    }
    metaDescription += 'En uygun fiyat, hızlı kargo, güvenli ödeme. LeaserTech\'ten hemen satın alın!';

    let title = brand ? `${productName} - ${brand}` : productName;
    if (title.length > 52) {
      title = `${title.substring(0, 49)}...`;
    }
    title += ' | LeaserTech';

    const allKeywords = [
      productName,
      brand,
      ...categories,
      ...categoryKeywords,
      'LeaserTech',
      'online alışveriş',
      'hızlı teslimat'
    ].filter(Boolean);

    return {
      title,
      description: metaDescription,
      keywords: [...new Set(allKeywords)].join(', ')
    };
  },

  category: (categoryName) => {
    if (CATEGORY_SEO[categoryName]) {
      return CATEGORY_SEO[categoryName];
    }

    return {
      title: `${categoryName} - LeaserTech | Elektronik Aksesuarları`,
      description: `${categoryName} kategorisindeki ürünleri LeaserTech güvencesiyle keşfedin. Uygun fiyat, hızlı kargo, güvenli ödeme.`,
      keywords: `${categoryName}, elektronik aksesuarları, LeaserTech, ${categoryName} fiyatları`,
      intro: `${categoryName} kategorisindeki ürünleri uygun fiyatlarla inceleyin.`
    };
  },

  search: (searchTerm) => {
    const normalized = searchTerm.trim().toLowerCase();
    const matchedKey = Object.keys(SEARCH_SEO).find(
      (key) => normalized === key || normalized.includes(key)
    );

    if (matchedKey) {
      return SEARCH_SEO[matchedKey];
    }

    return {
      title: `"${searchTerm}" Arama Sonuçları - LeaserTech`,
      description: `"${searchTerm}" için arama sonuçları. Bluetooth kulaklık, powerbank, hoparlör ve projeksiyon cihazları LeaserTech\'te.`,
      keywords: `${searchTerm}, elektronik aksesuarları, LeaserTech, ${searchTerm} fiyatları`,
      intro: `"${searchTerm}" araması için uygun ürünleri aşağıda bulabilirsiniz.`
    };
  },

  getCategoryIntro: (categoryName) => CATEGORY_SEO[categoryName]?.intro || null,
  getSearchIntro: (searchTerm) => {
    const normalized = searchTerm.trim().toLowerCase();
    const matchedKey = Object.keys(SEARCH_SEO).find(
      (key) => normalized === key || normalized.includes(key)
    );
    return matchedKey
      ? `${SEARCH_SEO[matchedKey].description}`
      : `"${searchTerm}" araması için uygun ürünleri aşağıda bulabilirsiniz.`;
  }
};

export const addProductStructuredData = (product) => {
  document.querySelectorAll('script[type="application/ld+json"]').forEach((script) => {
    try {
      const data = JSON.parse(script.textContent);
      if (data['@type'] === 'Product') {
        script.remove();
      }
    } catch (e) {
      script.remove();
    }
  });

  const imageUrls = (product.images || []).map((img) => {
    if (typeof img === 'string') {
      return img.startsWith('http') ? img : `${SITE_URL}${img}`;
    }
    if (typeof img === 'object' && img.url) {
      return img.url.startsWith('http') ? img.url : `${SITE_URL}${img.url}`;
    }
    return null;
  }).filter(Boolean);

  const category = Array.isArray(product.categories) && product.categories.length > 0
    ? product.categories[0]
    : 'Elektronik Aksesuarları';

  const structuredData = {
    '@context': 'https://schema.org',
    '@type': 'Product',
    name: product.name,
    description: product.description,
    category,
    brand: {
      '@type': 'Brand',
      name: product.brand || 'LeaserTech'
    },
    image: imageUrls.length > 0 ? imageUrls : [`${SITE_URL}/logo512.png`],
    offers: {
      '@type': 'Offer',
      price: parseFloat(product.price) || 0,
      priceCurrency: 'TRY',
      availability: (product.stock || 0) > 0 ? 'https://schema.org/InStock' : 'https://schema.org/OutOfStock',
      priceValidUntil: new Date(Date.now() + 365 * 24 * 60 * 60 * 1000).toISOString().split('T')[0],
      itemCondition: 'https://schema.org/NewCondition',
      url: `${SITE_URL}/product/${product.id}`,
      seller: {
        '@type': 'Organization',
        name: 'LeaserTech',
        url: SITE_URL
      }
    },
    sku: product.sku || product.id.toString(),
    mpn: product.sku || product.id.toString()
  };

  if (product.rating_average && parseFloat(product.rating_average) > 0) {
    structuredData.aggregateRating = {
      '@type': 'AggregateRating',
      ratingValue: parseFloat(product.rating_average),
      reviewCount: parseInt(product.rating_count, 10) || 0,
      bestRating: '5',
      worstRating: '1'
    };
  }

  if (product.specifications && Array.isArray(product.specifications) && product.specifications.length > 0) {
    structuredData.additionalProperty = product.specifications.map((spec) => ({
      '@type': 'PropertyValue',
      name: spec.name || spec.label || '',
      value: spec.value || ''
    }));
  }

  Object.keys(structuredData).forEach((key) => {
    if (structuredData[key] === undefined) {
      delete structuredData[key];
    }
  });

  const script = document.createElement('script');
  script.type = 'application/ld+json';
  script.id = 'product-structured-data';
  script.textContent = JSON.stringify(structuredData, null, 2);
  document.head.appendChild(script);
};

export const addBreadcrumbStructuredData = (breadcrumbs) => {
  document.querySelectorAll('script[data-seo="breadcrumb"]').forEach((script) => script.remove());

  const structuredData = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: breadcrumbs.map((crumb, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      name: crumb.name,
      item: crumb.url
    }))
  };

  const script = document.createElement('script');
  script.type = 'application/ld+json';
  script.dataset.seo = 'breadcrumb';
  script.textContent = JSON.stringify(structuredData);
  document.head.appendChild(script);
};

export const addWebSiteStructuredData = () => {
  if (document.getElementById('website-structured-data')) {
    return;
  }

  const structuredData = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: 'LeaserTech',
    url: SITE_URL,
    description: 'Bluetooth kulaklık, powerbank, hoparlör ve projeksiyon cihazları satan e-ticaret sitesi.',
    potentialAction: {
      '@type': 'SearchAction',
      target: `${SITE_URL}/products?search={search_term_string}`,
      'query-input': 'required name=search_term_string'
    }
  };

  const script = document.createElement('script');
  script.type = 'application/ld+json';
  script.id = 'website-structured-data';
  script.textContent = JSON.stringify(structuredData);
  document.head.appendChild(script);
};
